var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHamburgerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H20",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 8H20",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 15H20",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerIcon);
export default __webpack_public_path__ + "static/media/hamburgerIcon.2f097be154c750527191d30428b1ed37.svg";
export { ForwardRef as ReactComponent };